import React, {useState} from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AppBarInput from '../../../Components/AppBarInput';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import TextInput from '../../../Components/Input/TextInput';
import BtnCus from '../../../Components/Btn/BtnCus';
import Dropzone from 'react-dropzone';
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import Avatar from '@mui/material/Avatar';

export default function TambahAnggota(props) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [file, setFile] = useState(null)

  function submit(data) {
    // dispatch(updateGuru(data, navigate))
  }

  console.log(file)

  return (
    <div className='outer-input'>
      <AppBarInput title='Tambah Anggota' />
      <div>
        <Container maxWidth='lg' sx={{ mt: '20px' }}>
          <Paper sx={{ borderRadius: '12px' }}>
            <div style={{ padding: '20px' }}>
              <span>
                Tambah Anggota
              </span>
            </div>
            <Divider />
            <div style={{ padding: '20px' }}>
              <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column' }}>
                <Stack spacing={2}>
                  <TextInput label='Nama Lengkap' placeholder='Tulis Nama Lengkap' />
                  <TextInput label='Nomor Anggota' placeholder='Tulis Nomor Anggota' />
                  <TextInput label='Alamat' placeholder='Tulis Alamat' />
                  <TextInput label='Tempat, Tanggal Lahir' placeholder='Tulis Tempat, Tanggal Lahir' type='date' />
                  <TextInput label='Nama Cabang' placeholder='Tulis Nama Cabang' />
                  <TextInput label='Jabatan' placeholder='Tulis Jabatan' />
                  <TextInput label='No Hp' placeholder='Tulis No Hp' />
                  <TextInput label='Email' placeholder='Tulis Email' />
                  <div className='div-input'>
                    <div className='label-input'>Foto</div>
                    <div className='dropzone-div'>
                      <Dropzone onDrop={acceptedFiles => setFile(acceptedFiles[0])}>
                        {({ getRootProps, getInputProps }) => (
                          <section className='dropzone-div-section'>
                            <div {...getRootProps()}>
                              <input {...getInputProps()} />
                              {!file ?
                                <div style={{ flexDirection: 'column', height: 'fit-content' }}>
                                  <UploadFileOutlinedIcon sx={{ fontSize: '100px', color: '#999999' }} />
                                  <div style={{ marginBottom: '10px' }}>Upload Gambar Maksimal 3 Foto</div>
                                  <BtnCus text='Upload File' variant='outlined' style={{ height: '30px' }} color='error' size='small' />

                                </div> :
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                  <Avatar style={{ width: '100px', height: '100px', marginBottom: '10px' }} src={URL.createObjectURL(file)} />
                                  <BtnCus color='secondary' onClick={() => setFile(null)} variant='outlined' text='Ganti' />
                                </div>
                              }
                            </div>
                          </section>
                        )}
                      </Dropzone>

                    </div>
                  </div>
                  <div style={{ marginTop: '12px', marginLeft: '200px' }}>
                    <BtnCus variant='contained' type='submit' color='primary' text='Submit' style={{ width: '100px' }} />
                    <BtnCus variant='contained' color='secondary' text='Batal' style={{ marginLeft: '12px', width: '100px' }} onClick={() => navigate(-1)} />
                  </div>
                </Stack>
              </form>
            </div>
          </Paper>
        </Container>
      </div>
    </div>
  );
}
